import { useLocation, matchPath } from 'react-router-dom';
import ROUTE_PARENT_MAP from '../routes/RouteParentMap';

export default function useActivePath() {
  const location = useLocation();
  const { pathname, state } = location;

  // Dynamic routes opened from many screens
  if (pathname === '/workitem/add' || pathname === '/workitem/edit') {
    const parentRoute = state?.parentRoute || sessionStorage.getItem('parentRoute');

    if (parentRoute) return parentRoute;
  }

  // Static route mapping
  for (const [pattern, parentPath] of Object.entries(ROUTE_PARENT_MAP)) {
    if (matchPath({ path: pattern, end: false }, pathname)) {
      return parentPath;
    }
  }

  return pathname;
}
